<script setup>
import {ref} from 'vue'

import TariffsTableRow from "@/components/layouts/TariffsTableRow.ce.vue";
import CollapsableToggle from "@/components/forms/CollapsableToggle.ce.vue";
import {getGroupedRow, getRow} from "@/tariffs/table";
import {useChooserFormStore} from "@/store/forms/chooser";
import {storeToRefs} from "pinia";

const props = defineProps({
    rowGroups: {
        type: Array,
        default: function () {
            return [
                getGroupedRow(
                    {
                        name: 'group_row_trans_id'
                    },
                    [
                        getRow(
                            {
                                name: 'row_trans_id',
                            },
                            [
                                'cell_contents',
                            ],
                        ),
                    ]
                ),
            ];
        },
    },
});

const toggleGroups = ref({});

const formStore = useChooserFormStore();
const { debug } = storeToRefs(formStore);

props.rowGroups.forEach((rowGroup, index) => {
    let defaultToggle = false;
    if (debug.value) {
        defaultToggle = true;
    }
    toggleGroups.value[index] = rowGroup['defaultToggle'] === undefined ? defaultToggle: rowGroup['defaultToggle'];
});
</script>

<template>
    <template v-for="(sectionRow, sectionIndex) in props.rowGroups" :key="sectionIndex">
        <template v-if="sectionRow.visible === undefined ? true : sectionRow.visible">
            <TariffsTableRow
                :row-index="sectionIndex"
                :cell-heading="sectionRow.name"
            >
                <template #heading_pre>
                    <div class="mr-4">
                        <CollapsableToggle
                            v-model="toggleGroups[sectionIndex]"
                            @update-toggle="newValue => toggleGroups[sectionIndex] = newValue"
                        />
                    </div>
                </template>
            </TariffsTableRow>
            <template v-for="(row, rowIndex) in sectionRow.rows" :key="rowIndex">
                <TariffsTableRow
                    :section-index="sectionIndex"
                    :row-index="rowIndex"
                    :cell-heading="row.name"
                    :cells="row.cells"
                    :is-highlighted="row.isHighlighted"
                    :is-enabled="row.enabled"
                    :is-visible="row.toggleable === undefined ? true : toggleGroups[sectionIndex]"
                    :has-total-amount="row.hasTotalAmount"
                    :translation-context="row.translationContext"
                />
            </template>
        </template>
    </template>
</template>
